import { render, staticRenderFns } from "./Filtering.vue?vue&type=template&id=206a3918&scoped=true&"
import script from "./Filtering.vue?vue&type=script&lang=js&"
export * from "./Filtering.vue?vue&type=script&lang=js&"
import style0 from "./Filtering.vue?vue&type=style&index=0&id=206a3918&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206a3918",
  null
  
)

export default component.exports